<template>
    <div class="col-12 px-0">
        <multiselect
            :searchable=true :close-on-select=false
            id="criteria" v-model="chosenCriteria" :options="criteria"
            :multiple="true"
            :custom-label="criterionName"
            track-by="id"
            :disabled="false"
            :placeholder="$lang('Wybierz kryteria')"
            :selectLabel="$lang('Wybierz kryterium')"
            :selectedLabel="$lang('Wybrane kryterium')"
            :deselectLabel="$lang('Usuń kryterium')"
        ></multiselect>
        <input v-for="chosenCriterion in chosenCriteria" name="criteria[]" :value="chosenCriterion.id" hidden>
    </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
    name: "multiselect-criteria",
    components: {Multiselect},
    props: {
        criteria: Array,
        chosen_criteria: Array,
    },
    data() {
        return {
            chosenCriteria: this.chosen_criteria,
        }
    },
    methods: {
        criterionName({name}) {
            return name;
        },
    }
}
</script>

<style scoped>

</style>
